import { IonBackButton, IonButton, IonButtons, IonCol, IonHeader, IonIcon, IonImg, IonRow, IonTitle, IonToolbar } from "@ionic/react"
import { arrowForwardOutline, menuOutline } from "ionicons/icons"
import './Toolbar.css'

interface Props {
    title: string,
    color?: string,
    subTitle?: string,
    hasMenuButton?: boolean,
    hasBackButton?: boolean,
    menuButtonClick?: any
}

const Toolbar: React.FC<Props> = (props) => {
    let headerClassName = ["toolbar ion-no-border"];
    let color = props.color;

    if (color !== undefined) {
        headerClassName.push(color);
    }

    return (
        <IonHeader className={headerClassName.join(" ").toString()}>
            <IonToolbar>
                {props.hasMenuButton ?
                    <IonButtons slot="start" onClick={props.menuButtonClick}>
                        <IonButton shape="round" color="white">
                            <IonIcon icon="assets/images/menu.svg" />
                        </IonButton>
                    </IonButtons> : null}
                {props.hasBackButton ?
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/" color="white" text="" className="back-button" mode={window.layoutMode}></IonBackButton>
                    </IonButtons> : null}

                <div className="title-container">
                    <IonTitle className="title">{props.title}</IonTitle>

                    {props.subTitle != null && props.subTitle!!.length > 0 ?
                        <IonCol size="12">
                            <IonTitle className="subtitle">{props.subTitle}</IonTitle>
                        </IonCol> : null
                    }
                </div>

                <IonButtons slot="end">
                    {props.children}
                </IonButtons>
            </IonToolbar>
        </IonHeader>
    )
}

export default Toolbar